export default __webpack_public_path__ + "static/media/47577235_403291563543962_8028839317126250496_n.39dd2fe7.png";